import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {LabelPrimitivesOperatorParameters} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"
import {
    GeometryLabelPrimitivesOperatorNode,
    labelPrimitivesOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"

export type CurveGeometryLabelPrimitivesOperatorParameters = LabelPrimitivesOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryLabelPrimitivesOperatorParameters> = {
    nodeClass: "CurveGeometryLabelPrimitivesOperator",
    validation: {
        parameters: labelPrimitivesOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryLabelPrimitivesOperator
    extends GeometryLabelPrimitivesOperatorNode<1, CurveGeometryAttributeLikeNode>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
